import { render, staticRenderFns } from "./ImgSwiperV2.vue?vue&type=template&id=998ac55a&scoped=true&"
import script from "./ImgSwiperV2.vue?vue&type=script&lang=js&"
export * from "./ImgSwiperV2.vue?vue&type=script&lang=js&"
import style0 from "./ImgSwiperV2.vue?vue&type=style&index=0&id=998ac55a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998ac55a",
  null
  
)

export default component.exports